import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOTE_ENCOUNTER_TYPE_LIST,
    CLEAR_NOTE_ENCOUNTER_TYPE_LIST_ERROR,
    LOAD_NOTE_ENCOUNTER_TYPE_LIST_REQUEST,
    LOAD_NOTE_ENCOUNTER_TYPE_LIST_SUCCESS,
    LOAD_NOTE_ENCOUNTER_TYPE_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOTE_ENCOUNTER_TYPE_LIST,
    CLEAR_ERROR: CLEAR_NOTE_ENCOUNTER_TYPE_LIST_ERROR,
    LOAD_REQUEST: LOAD_NOTE_ENCOUNTER_TYPE_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_NOTE_ENCOUNTER_TYPE_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_NOTE_ENCOUNTER_TYPE_LIST_FAILURE
}